import { orange } from '@/theme/colors'
import styled from 'styled-components'

export const CardContainer = styled.div<{
	$isDragging?: boolean
	$isOver?: boolean
}>`
	background: #ffffff;
	border: 1px solid #e1e5e9;
	border-radius: 8px;
	padding: 0.85rem 1rem 0.9rem;
	cursor: grab;
	transition: all 0.2s ease;
	box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
	position: relative;
	touch-action: none;
	display: flex;
	flex-direction: column;
	gap: 0.55rem;

	&:hover {
		box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
		transform: translateY(-1px);
	}

	${props =>
		props.$isDragging &&
		`
    opacity: 0.5;
    transform: rotate(5deg);
    box-shadow: 0 8px 25px rgba(0, 0, 0, 0.25);
    z-index: 1000;
  `}

	${props =>
		props.$isOver &&
		`
    background: #f8f9ff;
    border-color: #007bff;
    box-shadow: 0 4px 12px rgba(0, 123, 255, 0.15);
  `}

	&:active {
		cursor: grabbing;
	}
`

export const DraggingPlaceholder = styled.div<{
	$transform?: string
	$transition?: string
}>`
	transform: ${({ $transform }) => $transform};
	transition: ${({ $transition }) => $transition};
	opacity: 0;
	height: 0;
	margin: 0;
	padding: 0;
	overflow: hidden;
`

export const CardHeader = styled.div`
	display: flex;
	justify-content: space-between;
	align-items: flex-start;
`

export const CardTitle = styled.h4`
	margin: 0;
	font-size: 0.95rem;
	font-weight: 600;
	color: #333;
	flex: 1;
	line-height: 1.4;
	word-break: break-word;
`

export const PillRow = styled.div`
	display: flex;
	flex-direction: row;
	align-items: center;
	gap: 0.4rem;
	flex-wrap: wrap;
`

export const CategoryPill = styled.span`
	background-color: ${orange};
	color: #ffffff;
	padding: 0.15rem 0.55rem;
	border-radius: 999px;
	font-size: 0.7rem;
	font-weight: 600;
	letter-spacing: 0.01em;
`

export const TimePill = styled.span`
	background-color: #f0f0f0;
	color: #4b5563;
	padding: 0.15rem 0.55rem;
	border-radius: 999px;
	font-size: 0.7rem;
	font-weight: 500;
`

export const IconRow = styled.div`
	display: flex;
	flex-direction: row;
	align-items: center;
	gap: 0.45rem;
	margin-top: 0.1rem;
`

export const IconButton = styled.div`
	display: inline-flex;
	align-items: center;
	gap: 3px;
	color: #6b7280;
	font-size: 0.7rem;
	font-weight: 600;
	line-height: 1;

	svg {
		display: block;
	}
`
